import { render } from "./BrandTiskaraZagreb.vue?vue&type=template&id=41db40ff"
import script from "./BrandTiskaraZagreb.vue?vue&type=script&lang=ts"
export * from "./BrandTiskaraZagreb.vue?vue&type=script&lang=ts"

import "./BrandTiskaraZagreb.vue?vue&type=style&index=0&id=41db40ff&lang=scss"
script.render = render

export default script